module.exports = __webpack_public_path__ + "static/img/Interior_Melamine.9e693ed.jpg";